import { qs, qsa, addGlobalEventListener } from './utils.js';

var b = document.querySelector(".enter");
  if (b) {
      enterView({
          selector: '.enter',
          enter: function (el) {
          el.classList.add('entered');
          },
          offset: 0.2,
      });
  }


var lazyLoadInstance = new LazyLoad ({})

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});


var mq = window.matchMedia("(max-width: 899px)")

function noScroll() {
  if ( document.querySelector('body').classList.contains('no-scroll')) {
    document.querySelector('body').classList.remove('no-scroll');
  } else {
    document.querySelector('body').classList.add('no-scroll');
  }
}

// function resScroll() {
//   document.querySelector('body').classList.toggle('no-scroll');
// }



var modal_backdrop = document.querySelector('.modal-backdrop');
function bdToggle() {
  modal_backdrop.classList.toggle('open');
  noScroll();
}

// Cart Toggle
function toggleCart() {            
    document.querySelector('#cart').classList.toggle('open');
    bdToggle()
}

function toggleMobileMenu() {    
    document.querySelector('#mm').classList.toggle('dn');
    bdToggle()
}

addGlobalEventListener("click", ".mm-trigger", e => {
    toggleMobileMenu();
})


document.querySelectorAll('*[data-mm-trigger]').forEach((button) =>
      button.addEventListener('click', function(event) {
        toggleMobileMenu()
      })
);

document.querySelectorAll('*[data-qc-trigger]').forEach((button) =>
      button.addEventListener('click', function(event) {
        event.preventDefault()
        toggleCart()
      })
);
/* Open Cart */

var enquireBtn = document.querySelector('.enquire-btn');
if (enquireBtn != null) {
  enquireBtn.onclick = () => {
    document.querySelector('.contact-form-wrapper').classList.add('open');
    bdToggle()
  }
  document.querySelector('.close-right-modal').onclick = () => {
    document.querySelector('.contact-form-wrapper').classList.remove('open');
    bdToggle()
  }
}


// open search
document.querySelectorAll('.search-btn').forEach((button) =>
      button.addEventListener('click', function(event) {
        document.querySelector('.search-modal').classList.toggle('open');
        bdToggle();
      })
);

document.querySelector('.search-close').onclick = () => {
  document.querySelector('.search-modal').classList.remove('open');
  bdToggle()
}




// MOBILE MENU
document.querySelectorAll('*[data-sub-trigger]').forEach((button) =>
    button.addEventListener('click', function(event) {
      var target = event.target.dataset.name;
      var mmSub = document.querySelectorAll('.mobile-menu .sub');

      for (let i = 0; i < mmSub.length; i++) {
        const sub = mmSub[i];
        if (sub.dataset.name == target) {
          console.log(sub.dataset.name)
          sub.classList.remove('dn');
        }
      }

    })
);
document.querySelectorAll('*[data-sub-close]').forEach((button) =>
    button.addEventListener('click', function(event) {
      event.target.closest('.sub').classList.add('dn')
    })
);



// careers
var career_modal = document.querySelector('.careers-modal');
if (career_modal != null) {
  document.querySelectorAll('.careers-apply-btn').forEach((button) =>
    button.addEventListener('click', function(event) {
      career_modal.classList.toggle('open');
      bdToggle();

      var title = button.dataset.title;
      var tagline = button.dataset.tag;
      var hours = button.dataset.hours;
      var store = button.dataset.store;
      document.querySelector('.career-form-data .career-title').innerHTML = title;
      document.querySelector('.career-form-data .career-tag').innerHTML = tagline;
      document.querySelector('.career-form-data .career-hours').innerHTML = hours;
      document.querySelector('.career-form-data .career-store').innerHTML = store;

    })
  );

  document.querySelector('.careers-close').onclick = () => {
    document.querySelector('.careers-modal').classList.remove('open');
    bdToggle()
  }

}








// collection modals
var filter_modal = document.querySelector('.filter-modal');
var filter_btn = document.querySelector('.filter-btn');
var filter_close = document.querySelector('.filter-close');
var sort_modal = document.querySelector('.sort-modal');
var sort_btn = document.querySelector('.sort-btn');
var sort_close = document.querySelector('.sort-close');
if (filter_btn != null) {
  filter_btn.onclick = () => {
    filter_modal.classList.toggle('open');
    bdToggle();
  }
  filter_close.onclick = () => {
    filter_modal.classList.toggle('open');
    bdToggle();
  }
}
if (sort_btn != null) {
  sort_btn.onclick = () => {
    sort_modal.classList.toggle('open');
    bdToggle();
  }
  sort_close.onclick = () => {
    sort_modal.classList.toggle('open');
    bdToggle();
  }
}

//  click modal backdrop
modal_backdrop.onclick = () => {
  bdToggle()
  var right_modals = document.querySelectorAll('.right-modal')
  for (let i = 0; i < right_modals.length; i++) {
    const element = right_modals[i];
    element.classList.remove('open');
  }
}




// Product Carousel
// const swiperProductImages = new Swiper('.product-images', {
//   slidesPerView: 1,
//   direction: 'horizontal',    
//   draggable: true,  
//   loop: true,
//   grabCursor: false,  
//   navigation: {
//     nextEl: '.product-images .btn-next',
//     prevEl: '.product-images .btn-prev',
//   },
// });

// Toggle Sibling element
function toggleSibling(toggle) {
  var target = toggle.nextElementSibling,
  currentState = toggle.getAttribute('data-sibling-toggle')
  toggle.setAttribute('data-sibling-toggle', !currentState);
  target.classList.toggle('dn')
}

document.querySelectorAll('*[data-sibling-toggle]').forEach((button) =>
      button.addEventListener('click', function(event) {
        toggleSibling(button);
      })
);



var carousel_section = document.querySelectorAll('.carousel-section');
for (let i = 0; i < carousel_section.length; i++) {
  const carousel = carousel_section[i];
  var el = carousel.querySelector(".carousel-swiper");
  var swiper = new Swiper(el, {
    slidesPerView: 1.5,
    grabCursor: true, 
    draggable: true,  
  });
  
}





// pairs with block swiper
var swiper = new Swiper(".pairs-with-block", {
  effect: "fade",
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + "0" + (index + 1) + '</span>';
    },
  },
});




// feature collection swiper 
var feat_coll_swiper = document.querySelectorAll(".feature-collection.swiper");
if (feat_coll_swiper != null && mq.matches) {

  for (let i = 0; i < feat_coll_swiper.length; i++) {
    const fc_swipe = feat_coll_swiper[i];
    var swiper = new Swiper(fc_swipe, {
      slidesPerView: 1.4,
      spaceBetween: 15
    });
  }

}

//location swiper 
var location_swiper = document.querySelectorAll(".location-swiper");
if (location_swiper != null && mq.matches) {

  for (let i = 0; i < location_swiper.length; i++) {
    const location_swipe = location_swiper[i];
    var swiper = new Swiper(location_swipe, {
      slidesPerView: 1.2,
      spaceBetween: 15
    });
  }

}

// PDP Swiper
var pdp_swiper = document.querySelectorAll(".swiper-pdp");
if (pdp_swiper != null && mq.matches) {

  for (let i = 0; i < pdp_swiper.length; i++) {
    const pdp_swipe = pdp_swiper[i];
    var swiper = new Swiper(pdp_swipe, {
      slidesPerView: 1,
      spaceBetween: 15
    });
  }

}







